<template>
    <router-view :captureFrontUrl="captureFrontUrl" pictureCover/>
</template>
<script>
import { FRONT_CAPTURE } from '@/config';

export default {
    name: 'BriefWrapper',
    data () {
        return {
            captureFrontUrl: FRONT_CAPTURE,
        };
    },
};
</script>
